import api from '../api';
import axios from 'axios';

export default {
    DETECT_PROVIDER: (email) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.ImapEmail.DETECT_PROVIDER(email))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    CONNECT: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.ImapEmail.CONNECT(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    LIST: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.ImapEmail.LIST())
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_BY_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.ImapEmail.GET_BY_ID(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_ALL_INBOX_IMAP: (query, signal) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.ImapEmail.GET_ALL_INBOX_IMAP(query), { signal })
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    SEARCH_IMAP: (query, signal) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.ImapEmail.SEARCH_IMAP(query), { signal })
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    DELETE: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.ImapEmail.DELETE(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
};
